var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolToggleDicomOverlay = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.437 5.25a.625.625 0 1 1 0-1.25h1.35a.625.625 0 1 1 0 1.25h-1.35Zm4.08 0a.625.625 0 0 1 0-1.25h1.35a.625.625 0 1 1 0 1.25h-1.35Zm4.08 0a.625.625 0 1 1 0-1.25h1.35a.625.625 0 1 1 0 1.25h-1.35Zm4.413 1.966a.625.625 0 0 1-.635-.615 1.367 1.367 0 0 0-.328-.867.625.625 0 0 1 .951-.811c.392.46.616 1.042.627 1.658a.625.625 0 0 1-.615.635ZM9 7.831a.625.625 0 0 1-.625-.625v-.581c0-.343.066-.678.193-.99a.625.625 0 1 1 1.158.472 1.37 1.37 0 0 0-.101.518v.581c0 .346-.28.625-.625.625Zm15 3.465a.625.625 0 0 1-.625-.625V9.32a.625.625 0 1 1 1.25 0v1.35c0 .345-.28.625-.625.625ZM9 11.91a.625.625 0 0 1-.625-.625v-1.35a.625.625 0 0 1 1.25 0v1.35c0 .346-.28.625-.625.625Zm15 3.465a.625.625 0 0 1-.625-.625V13.4a.625.625 0 0 1 1.25 0v1.35c0 .345-.28.625-.625.625ZM9 15.99a.625.625 0 0 1-.625-.625v-1.35a.625.625 0 1 1 1.25 0v1.35c0 .346-.28.625-.625.625Zm15.148 3.143a.625.625 0 1 1-1.022-.72c.161-.229.249-.501.249-.789v-.144a.625.625 0 1 1 1.25 0v.144c0 .547-.168 1.07-.477 1.51Zm-13.822.476a.625.625 0 0 1-.874.135 2.627 2.627 0 0 1-.995-1.466.625.625 0 0 1 1.211-.31c.08.308.265.58.522.767.279.204.34.595.136.874Zm10.324.64a.625.625 0 1 1 0-1.25H22a.625.625 0 1 1 0 1.25h-1.35Zm-4.08 0a.625.625 0 0 1 0-1.25h1.35a.625.625 0 0 1 0 1.25h-1.35Zm-4.08 0a.625.625 0 1 1 0-1.25h1.35a.625.625 0 1 1 0 1.25h-1.35Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.168 9.125H5.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-.17h0",
  stroke: "currentColor",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}))));
export { SvgToolToggleDicomOverlay as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-toggle-dicom-overlay.svg";